import { gql } from '@apollo/client';

export const GET_TIMEOS_DATA = gql`
  query timeosData {
    timeosUser {
      id
      username
      isSynchronized
    }
    timeosCustomerId
  }
`;
